import { styled } from 'styled-components';

import DoneIcon from '../../../assets/icons/done-icon.svg?react';
import WarningIcon from '../../../assets/icons/status-warning.svg?react';

const ValidationContainerSC = styled.div<{ $isValid?: boolean }>`
  color: ${(props) => (props.$isValid ? props.theme.colors.emeraldGreen[100] : props.theme.colors.alertRed[100])};
  display: flex;
  margin-inline-start: auto;
  height: 1rem;
`;

const ValidationStatusSC = styled.div`
  margin-inline: 0.25rem;
  font-weight: 500;
`;

type Props = {
  isValid?: boolean;
  validationPassedLabel?: string;
  validationWarningLabel?: string;
};

const getValidationStatusValue = (
  isValid?: boolean,
  validationPassedLabel?: string,
  validationWarningLabel?: string,
) => {
  if (isValid === undefined) {
    return null;
  }

  if (isValid) {
    return (
      <>
        <ValidationStatusSC>{validationPassedLabel ?? 'Passed'}</ValidationStatusSC>
        <DoneIcon />
      </>
    );
  }

  return (
    <>
      <ValidationStatusSC>{validationWarningLabel ?? 'Warning'}</ValidationStatusSC>
      <WarningIcon />
    </>
  );
};

export const ValidationStatus = ({ isValid, validationPassedLabel, validationWarningLabel }: Props) => {
  return (
    <ValidationContainerSC $isValid={isValid}>
      {getValidationStatusValue(isValid, validationPassedLabel, validationWarningLabel)}
    </ValidationContainerSC>
  );
};
